import { Box, Typography } from '@mui/material';
import { PieChart } from '../../../../common/inventory/components/PieChart';
import { SeverityData } from './SeverityData';

type SeverityItem = {
  name: string;
  amount: number;
  color: string;
  textColor: string;
  backgroundColor: string;
};

export type SeverityChartProps = {
  title?: string;
  items: SeverityItem[];
  layout?: 'row' | 'column';
  padding?: number;
};

export const SeverityChart = ({ title, items, layout = 'column', padding = 0 }: SeverityChartProps) => {
  return (
    <Box sx={{ p: padding, backgroundColor: 'white', overflow: 'hidden', height: 1 }}>
      <Box sx={{ width: '50%', display: 'inline-block', height: 1, pt: title ? 0 : 2 }}>
        {title && (
          <Typography component="p" variant="overline" sx={{ fontWeight: 500, color: 'text.secondary', ml: 1.5, mb: 1 }}>
            {title}
          </Typography>
        )}
        <PieChart data={items} radius={90} chartWidth={25} onMouseEnter={() => {}} onMouseLeave={() => {}} disableAnimation />
      </Box>
      <Box sx={{ width: '50%', display: 'inline-block', float: 'right', height: 1, pt: 0.5 }}>
        <SeverityData items={items} layout={layout} />
      </Box>
    </Box>
  );
};
